/**
 * asForm Higher Order Component
 */
import React, { Component } from 'react';
import { action } from 'mobx';

export default function asForm(MyComponent, formDataProp) {
  return class Form extends Component {
    constructor(props) {
      super(props);
      this.updateProperty = this.updateProperty.bind(this);
    }

    @action updateProperty(key, value) {
      this.props[formDataProp][key] = value;
    }

    render() {
      return (
        <MyComponent {...this.props} updateProperty={this.updateProperty} />
      );
    }
  };
}
